<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="control" title="솔루션" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                스마트팜 제품 솔루션
            </template>
            <tit-wrap-large class="mb-0">
                식물공장의 다양한 재배환경을 모니터링하여 <br class="d-none d-lg-block" />
                작물의 생육환경을 제어하는 <b>식물공장 통합관제 시스템</b>
                <template #text> 측정 센서를 통해 식물공장내 구역별 상태와 작물의 근권부(뿌리 환경)를 모니터링하여 작물 생장에 필요한 적정량의 영양분과 <br class="d-none d-lg-block" />관수제어 및 환경 제어가 가능합니다. 효율적인 식물공장 운영을 가능하게 하는 식물공장 통합관제 시스템입니다. </template>
            </tit-wrap-large>
        </page-section>

        <page-section class="d-flex align-center min-h-lg-980px">
            <div class="page-section__bg" style="background-image:url(/images/sub/solution/plant/control-bg.jpg);"></div>
            <v-img max-width="350" :aspect-ratio="700 / 2596" src="/images/sub/solution/plant/control-img-mo.png" class="d-md-none mx-auto" data-aos="fade" data-aos-delay="100" />
            <v-img max-width="1200" :aspect-ratio="1200 / 216" src="/images/sub/solution/plant/control-img.png" class="d-none d-md-block mx-auto" data-aos="fade" data-aos-delay="100" />
        </page-section>

        <page-section class="grey lighten-5">
            <v-card outlined rounded="" data-aos="fade" data-aos-delay="100">
                <div class="d-flex pa-30px pa-md-40px pa-lg-80px">
                    <v-img max-width="1000" :aspect-ratio="1000 / 634" src="/images/sub/solution/plant/control-img2.png" class="mx-auto" />
                </div>
            </v-card>

            <div class="pt-30px pt-md-40px pt-lg-80px">
                <v-row class="ma-n20px ma-md-n30px">
                    <v-col cols="12" md="6" class="pa-20px pa-md-30px" data-aos="fade-left" data-aos-delay="100">
                        <tit-wrap-sprout>
                            식물공장 및 식물 근권부 및 환경 모니터링
                        </tit-wrap-sprout>

                        <txt-item>
                            <template #title>측정항목</template>
                            온도, 습도, pH, EC, CO2, LED인공광
                        </txt-item>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-20px pa-md-30px" data-aos="fade-left" data-aos-delay="200">
                        <tit-wrap-sprout>
                            식물공장 통합관제 제어 시스템
                        </tit-wrap-sprout>

                        <txt-item>
                            <template #title>제어항목</template>
                            냉난방, 공조 환기, LED인공광, 칠러 및 관수, <br class="d-none d-lg-block" />재배대 물수위
                        </txt-item>
                    </v-col>
                </v-row>
            </div>
        </page-section>

        <page-section class="page-section--last">
            <v-card outlined rounded="" data-aos="fade" data-aos-delay="100">
                <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                    <div class="pa-30px pa-md-40px px-lg-80px">
                        <v-img max-width="770" :width="$vuetify.breakpoint.lgAndUp ? '770' : ''" :aspect-ratio="770 / 376" src="/images/sub/solution/plant/control-img3.png" class="mx-auto" />
                        <div class="pt-30px pt-md-40px pt-lg-60px">
                            <tit-wrap-small>
                                IoT 복합환경제어 시스템
                                <template #text> PC와 모바일로 작물의 생장 정보 모니터링과 환경 제어가 가능한 시스템입니다. </template>
                            </tit-wrap-small>
                        </div>
                    </div>
                </v-responsive>
            </v-card>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
